var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2"},React.createElement("path",{"d":"M1 8h14M8 1l7 7-7 7"})));
}

ArrowRight.defaultProps = {"width":"16","height":"16","data-name":"Layer 1","viewBox":"0 0 16 16"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
